import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
@Injectable()
export class RuleEngineService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService
    ) { }

    getRider(quotationIO) {
        var self = this;
        let riderDataSubject: Subject<any> = new Subject<any>();
             var temList = [{ 'Flood': 'OPTIONAL' }]
        let fetchRidersListURL = "quotation/ridersList"
        this.apiRequest.post(fetchRidersListURL, quotationIO)
              .subscribe(
            jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Riders Fetched")
                    console.log(jsonResp)
                } else {
                    console.log("Rider hardcoded")
                    console.log(jsonResp)
                }
                riderDataSubject.next(jsonResp);

            },
            errResp => {
                console.log("POST ERROR")
                riderDataSubject.next(temList);
            })
        return riderDataSubject;
    }

    fetchRiders(product) {
        let riderListSubject: Subject<any> = new Subject<any>();
        let pathVariables = [];
        pathVariables.push(product || null);

        // let riderListServiceURL = 'fetchRiders' + product;
        let DataList: any[] = [];
        let riderListServiceURL = 'fetchRiders';
        this.apiRequest.getCallWithAPIMapper(riderListServiceURL, null, null, pathVariables)
        // this.apiRequest.getCallWithAPIMapper(riderListServiceURL)
            .subscribe(jsonResp => {
                
                jsonResp.forEach(element => {
                    DataList.push(element);
                });
                
                riderListSubject.next(DataList);
                riderListSubject.complete();

            })

        return riderListSubject;

    }

}


